
const m = window.require("embercom/lib/scroll-into-view-if-not-visible");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
